module.exports = __webpack_public_path__ + "static/media/NotoSansTC-Thin-Alphabetic.45578319.woff2";